import React, {
  useEffect,
  useState,
  Fragment,
  useCallback,
  useContext,
} from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import CheckboxFir from "components/sales/Input/checkbox/checkboxFir";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import "./fir.css";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import DatePicker from "components/sales/datePicker/datePicker";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { toast } from "react-toastify";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const FirstInteractionFIRForm = ({
  match,
  history,
  firAutofill,
  firData,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterFieldsData, setFilterFieldsData] = useState({});
  const { baseUrl } = useContext(BaseUrl);
  const [inputList, setInputList] = useState([
    {
      date: "",
      society_name: "",
      city_name: "",
      meeting_person_name: "",
      interaction_designation: "",
      total_flats: "",
      total4w2w: "",
      total_tags_ordered: "",
      total_4w2w_tags_ordered: "",
      signage_information: "",
      branded_signage: "",
      fitkit_qty: "",
      fitkit_price: "",
      integration_type: "",
      integration_remark: "",
      tentative_livedate: "",
      internet_available: "",
      occupied_slots: "",
      free_slots: "",
      visitors_parking_slots: "",
      estimated_allotted: "",
      rental_price: "",
      capex_price_per_gate: "",
      payment_frquency: "",
      have_you_checked: "",
      file_upload: "",
      no_of_helpdesk: "",
      payment_terms: "",
      agreement_signed_by: "",
      designation: "",
      amount_given: "",
      payment_details:
        firData?.payment_details?.name !== undefined
          ? firData?.payment_details?.name
          : firData?.payment_details,
      dashboard_training: "",
      dashboard_training_remark: "",
      raise_complaints: "",
      raise_complaints_remark: "",
      payment_briefing: "",
      payment_briefing_remark: "",
      carnival_overview: "",
      carnival_overview_remark: "",
      troubleshooting_faq: "",
      troubleshooting_faq_remark: "",
      tag_activation: "",
      park_partner: "",
      car_display: "",
      daily_car_cleaning: "",
      daily_car_cleaning_remark: "",
      inauguration: "",
      chiefguest_name: "",
      chiefguest_designation: "",
      reason_for_not_opting: "",
      carnival_datetime: "",
      identified_area: "",
      flag_installation: "",
      aligning_RWA: "",
      push_message: "",
      confirmation_park: "",
      confirmation_remark: "",
      rm_name: "",
      client_name: "",
      client_rental_self_deposit: "",
      client_rental_online_mode: "",
      late_payment_fees_check: "",
      auto_shuts_off_check: "",
      residents_tags_charge:'',
      charge_reason: '',
      meeting_count: '',
      deal_duration: '',
      evaluated_vendor: '',
      evaluated_vendor_others_reason: '',
      betterment_reason: '',
    },
  ]);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState("");

  // useEffect(async () => {
  //   console.log(match?.params?.id);
  // }, []);

  const [formData, setFormData] = useState(inputList);
  const [showConstantInput, setShowConstantInput] = useState(false);

  console.log(formData);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formData);
    // console.log(JSON.stringify(formData));
    setIsLoading(true);
    const payload = {
      firData: formData,
      fir_type: 1,
      site_id: match?.params?.id,
    };
    const url = `${Config.installation.firFormSubmit}`;
    const { data } = await axios.post(url, payload);
    console.log(data + JSON.stringify(data));
    if(data.response?.data === true) {
      setIsLoading(false);
      history.push(`${baseUrl}/gate/fir-integration/${match?.params?.id}/stage/7`);
    } else {
      toast.error('Fir not submitted successfully.');
    }
    return false;
  };

  const handleInput2Value = (val, key) => {
    if (key === "file_upload" && val !== "") {
      setFileUpload(val);
    }
    const list = [...formData];
    list[0][key] = val;
    setFormData(list);
  };

  const handleSaveDraft = async (val) => {
    const payload = {
      firData: formData,
      fir_type: 1,
      site_id: match?.params?.id,
    };
    try {
      const url = Config.installation.saveasDraft;
      const response = await axios.post(url, payload);
      console.log('Saved as Draft:', val);
    } catch (error) {
      console.error('Error saving as draft:', error);
    }
  };

  useEffect(() => {
    if (firAutofill !== null && match.params.id)
      (async () => {
        setIsLoading(true);
        await firAutofill(match.params.id);
        setIsLoading(false);
      })();
  }, [firAutofill, match.params.id]);

  useEffect(() => {
    if (firData) {
      console.log(firData);
      setIsLoading(true);
      inputList[0]["date"] = firData?.date || "";
      inputList[0]["society_name"] = firData?.society_name || "";
      inputList[0]["city_name"] = firData?.city_name || "";
      inputList[0]["meeting_person_name"] = firData?.meeting_person_name || "";
      inputList[0]["interaction_designation"] =
        firData?.interaction_designation || "";
      inputList[0]["total_flats"] = firData?.total_flats || "";
      inputList[0]["total4w2w"] = firData?.total4w2w || "";
      inputList[0]["total_tags_ordered"] = firData?.total_tags_ordered || "";
      inputList[0]["total_4w2w_tags_ordered"] =
        firData?.total_4w2w_tags_ordered || "";
      inputList[0]["signage_information"] = firData?.signage_information || "";
      inputList[0]["branded_signage"] = firData?.branded_signage || "";
      inputList[0]["fitkit_qty"] = firData?.fitkit_qty || "";
      inputList[0]["fitkit_price"] = firData?.fitkit_price || "";
      inputList[0]["integration_type"] = firData?.integration_type || "";
      inputList[0]["integration_remark"] = firData?.integration_remark || "";
      inputList[0]["tentative_livedate"] = firData?.tentative_livedate || "";
      inputList[0]["internet_available"] = firData?.internet_available || "";
      inputList[0]["occupied_slots"] = firData?.occupied_slots || "";
      inputList[0]["free_slots"] = firData?.free_slots || "";
      inputList[0]["visitors_parking_slots"] =
        firData?.visitors_parking_slots || "";
      inputList[0]["estimated_allotted"] = firData?.estimated_allotted || "";
      inputList[0]["rental_price"] = firData?.rental_price || "";
      inputList[0]["capex_price_per_gate"] =
        firData?.capex_price_per_gate || "";
      inputList[0]["payment_frquency"] = firData?.payment_frquency || "";
      inputList[0]["payment_details"] =
        firData?.payment_details?.name !== undefined
          ? firData?.payment_details?.name
          : firData?.payment_details || "";
      inputList[0]["have_you_checked"] = firData?.have_you_checked || "";
      inputList[0]["file_upload"] = firData?.file_upload || "";
      setFileUpload(firData?.file_upload || "");
      inputList[0]["no_of_helpdesk"] = firData?.no_of_helpdesk || "";
      inputList[0]["payment_terms"] = firData?.payment_terms || "";
      inputList[0]["agreement_signed_by"] = firData?.agreement_signed_by || "";
      inputList[0]["designation"] = firData?.designation || "";
      inputList[0]["amount_given"] = firData?.amount_given || "";
      // inputList[0]['payment_details'] = firData?.payment_details || "";
      inputList[0]["dashboard_training"] = firData?.dashboard_training || "";
      inputList[0]["dashboard_training_remark"] =
        firData?.dashboard_training_remark || "";
      inputList[0]["raise_complaints"] = firData?.raise_complaints || "";
      inputList[0]["raise_complaints_remark"] =
        firData?.raise_complaints_remark || "";
      inputList[0]["payment_briefing"] = firData?.payment_briefing || "";
      inputList[0]["payment_briefing_remark"] =
        firData?.payment_briefing_remark || "";
      inputList[0]["carnival_overview"] = firData?.carnival_overview || "";
      inputList[0]["carnival_overview_remark"] =
        firData?.carnival_overview_remark || "";
      inputList[0]["troubleshooting_faq"] = firData?.troubleshooting_faq || "";
      inputList[0]["troubleshooting_faq_remark"] =
        firData?.troubleshooting_faq_remark || "";
      inputList[0]["tag_activation"] = firData?.tag_activation || "";
      inputList[0]["park_partner"] = firData?.park_partner || "";
      inputList[0]["car_display"] = firData?.car_display || "";
      inputList[0]["daily_car_cleaning"] = firData?.daily_car_cleaning || "";
      inputList[0]["daily_car_cleaning_remark"] =
        firData?.daily_car_cleaning_remark || "";
      inputList[0]["inauguration"] = firData?.inauguration || "";
      inputList[0]["chiefguest_name"] = firData?.chiefguest_name || "";
      inputList[0]["chiefguest_designation"] =
        firData?.chiefguest_designation || "";
      inputList[0]["reason_for_not_opting"] =
        firData?.reason_for_not_opting || "";
      inputList[0]["carnival_datetime"] = firData?.carnival_datetime || "";
      inputList[0]["identified_area"] = firData?.identified_area || "";
      inputList[0]["flag_installation"] = firData?.flag_installation || "";
      inputList[0]["aligning_RWA"] = firData?.aligning_RWA || "";
      inputList[0]["push_message"] = firData?.push_message || "";
      inputList[0]["confirmation_park"] = firData?.confirmation_park || "";
      inputList[0]["confirmation_remark"] = firData?.confirmation_remark || "";
      inputList[0]["rm_name"] = firData?.rm_name || "";
      inputList[0]["client_name"] = firData?.client_name || "";
      inputList[0]["client_rental_self_deposit"] = firData?.client_rental_self_deposit || "";
      inputList[0]["client_rental_online_mode"] = firData?.client_rental_online_mode || "";
      inputList[0]["late_payment_fees_check"] = firData?.late_payment_fees_check || "";
      inputList[0]["auto_shuts_off_check"] = firData?.auto_shuts_off_check || "";
      inputList[0]["residents_tags_charge"] = firData?.residents_tags_charge || "";
      inputList[0]["charge_reason"] = firData?.charge_reason || "";
      inputList[0]["deal_duration"] = firData?.deal_duration || "";
      inputList[0]["meeting_count"] = firData?.meeting_count || "";
      inputList[0]["evaluated_vendor"] = firData?.evaluated_vendor || "";
      inputList[0]["evaluated_vendor_others_reason"] = firData?.evaluated_vendor_others_reason || "";
      inputList[0]["betterment_reason"] = firData?.betterment_reason || "";
      setInputList(inputList);
      setIsLoading(false);
    }
  }, [firData]);

  // console.log('fir data ' + JSON.stringify(firData));

  return (
    <Layout
      title={localization.firstInteractionForm}
      isLoading={isLoading}
      isGoback={true}
    >
      <form onSubmit={handleSubmit}>
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">{localization.rwaFirForm}</div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.date}
                    errorMsg={localization.requiredProjectName}
                    type="text"
                    required
                    isStarRequired={true}
                    value={firData.date}
                    disabled={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "date");
                    }}
                  />
                </div>

                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.societyName}
                    errorMsg={localization.requiredProjectName}
                    type="text"
                    required
                    isStarRequired={true}
                    value={firData.society_name}
                    disabled={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "society_name");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.city}
                    errorMsg={localization.requiredCityName}
                    type="text"
                    required
                    value={firData.city_name}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "city_name");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.meetingPersonName}
                    errorMsg={localization.requiredMeetingPersonName}
                    type="text"
                    value={firData.meeting_person_name}
                    required
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "meeting_person_name");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.designation}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.interaction_designation}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "interaction_designation");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.totalFlats}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.total_flats}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "total_flats");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.total4W2W}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.total4w2w}
                    onFocus={(val) => handleSaveDraft(val)}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "total4w2w");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.totalTagsOrdered}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.total_tags_ordered}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "total_tags_ordered");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.total4W2WTagsOrdered}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.total_4w2w_tags_ordered}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "total_4w2w_tags_ordered");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.informationSignages}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.signage_information}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "signage_information");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.brandedSignage}
                    errorMsg={localization.designationError}
                    type="text"
                    value={firData.branded_signage}
                    required
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "branded_signage");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.fitkitQty}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.fitkit_qty}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "fitkit_qty");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.fitkitPrice}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.fitkit_price}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "fitkit_price");
                    }}
                  />
                </div>

                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.typeOfIntegration}
                    required
                    value={inputList[0]?.integration_type}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "integration_type");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.integration_type === "Yes" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.integrationRemark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={firData.integration_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "integration_remark");
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <>
                    {inputList.map((x, i) => {
                      return (
                        <DatePicker
                          label={localization.tentativeLiveDate}
                          required={false}
                          value={firData.tentative_livedate}
                          handleChange={(val) => {
                            handleInput2Value(val, "tentative_livedate");
                          }}
                        />
                      );
                    })}
                  </>
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.internetAvailabilty}
                    required
                    value={inputList[0]?.internet_available}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "internet_available");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <h5>Total Parking count in society for residents:</h5>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.occupiedSlots}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    onFocus={(val) => handleSaveDraft(val)}
                    value={firData.occupied_slots}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "occupied_slots");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.freeSlots}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.free_slots}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "free_slots");
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.visitorsParkingSlots}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.visitors_parking_slots}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "visitors_parking_slots");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.estimatedAllottedParkingSlotsPerFlat}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.estimated_allotted}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "estimated_allotted");
                    }}
                  />
                </div>
              </div>
              <div>
                <center>
                  <h5>
                  *Billing shall start after the installation irrespective
                  of internet or electricity availability
                  </h5>
                  <h5>Sales CheckPoint</h5>
                </center>
              </div>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.rentalPrice}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.rental_price}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "rental_price");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.capexPricePerGate}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.capex_price_per_gate}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "capex_price_per_gate");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.frequencyOfPayment}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.payment_frquency}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "payment_frquency");
                    }}
                  />
                </div>

                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.haveYouChecked}
                    required
                    value={inputList[0]?.have_you_checked}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      console.log(val.id);
                      handleInput2Value(val.id, "have_you_checked");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.have_you_checked === "No" && (
                  <>
                    <div className="form-group col-sm-2">
                      <FileUpload
                        id="addAttachment"
                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        onChange={(val) => {
                          handleInput2Value(val, "file_upload");
                        }}
                      >
                        <span className="btn btn-transparent">
                          {localization.chequeAttachment}
                        </span>
                      </FileUpload>
                    </div>

                    {fileUpload !== "" && (
                      <>
                        <div className="form-group col-sm-2">
                          <img
                            src={`${fileUpload}`}
                            style={{ width: "30%" }}
                          ></img>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.noOfHelpdesk}
                    errorMsg={localization.designationError}
                    type="number"
                    required
                    value={firData.no_of_helpdesk}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "no_of_helpdesk");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.paymentTerms}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.payment_terms}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "payment_terms");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.agreementSignedBy}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.agreement_signed_by}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "agreement_signed_by");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.designation}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.designation}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "designation");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.amountGivenToPark}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.amount_given}
                    isStarRequired={true}
                    onFocus={(val) => handleSaveDraft(val)}
                    handleChange={(val) => {
                      handleInput2Value(val, "amount_given");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.detailsOfPayment}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={formData[0]?.payment_details}
                    disabled={true}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "payment_details");
                    }}
                  />
                </div>
              </div>
              <h5>Training Completion Remarks</h5>
              <div className="row mt-3">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.dashboardTraining}
                    required
                    value={inputList[0]?.dashboard_training}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "dashboard_training");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.dashboard_training === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.remark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={firData.dashboard_training_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "dashboard_training_remark");
                      }}
                    />
                  </div>
                )}
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.howToRaiseComplaints}
                    required
                    value={inputList[0]?.raise_complaints}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "raise_complaints");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.raise_complaints === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.remark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={firData.raise_complaints_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "raise_complaints_remark");
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.paymentBriefing}
                    required
                    value={inputList[0]?.payment_briefing}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "payment_briefing");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.payment_briefing === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.remark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={firData.payment_briefing_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "payment_briefing_remark");
                      }}
                    />
                  </div>
                )}
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.carnivalOverview}
                    required
                    value={inputList[0]?.carnival_overview}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "carnival_overview");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.carnival_overview === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.remark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={firData.carnival_overview_remark}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "carnival_overview_remark");
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.troubleshootingFAQ}
                    required
                    value={inputList[0]?.troubleshooting_faq}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "troubleshooting_faq");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.troubleshooting_faq === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.remark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={firData.troubleshooting_faq_remark}
                      isStarRequired={true}
                      onFocus={(val) => handleSaveDraft(val)}
                      handleChange={(val) => {
                        handleInput2Value(val, "troubleshooting_faq_remark");
                      }}
                    />
                  </div>
                )}
              </div>

              <h5>Activities during the Carnival</h5>

              <div className="row mt-3">
                <div className="col-md-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.tagActivation}
                    required
                    value={inputList[0]?.tag_activation}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "tag_activation");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-md-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.parkPartner}
                    required
                    value={inputList[0]?.park_partner}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "park_partner");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    value={inputList[0]?.car_display}
                    label={localization.carDisplay}
                    required
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "car_display");
                    }}
                    isStarRequired={true}
                  />
                </div>

                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    value={inputList[0]?.daily_car_cleaning}
                    label={localization.dailyCarCleaning}
                    required
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "daily_car_cleaning");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.daily_car_cleaning === "No" && (
                  <div className="col-sm-6">
                    <ConstantInput
                      label={localization.remark}
                      errorMsg={localization.designationError}
                      type="text"
                      required
                      value={firData.daily_car_cleaning_remark}
                      isStarRequired={true}
                      onFocus={(val) => handleSaveDraft(val)}
                      handleChange={(val) => {
                        handleInput2Value(val, "daily_car_cleaning_remark");
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    value={inputList[0]?.inauguration}
                    label={localization.inauguration}
                    required
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "inauguration");
                    }}
                    isStarRequired={true}
                  />
                </div>

                {inputList[0]?.inauguration === "Yes" && (
                  <>
                    <div className="col-sm-6">
                      <ConstantInput
                        label={localization.chiefGuestName}
                        errorMsg={localization.designationError}
                        type="text"
                        required
                        value={firData.chiefguest_name}
                        isStarRequired={true}
                        handleChange={(val) => {
                          handleInput2Value(val, "chiefguest_name");
                        }}
                      />
                    </div>
                    <div className="col-sm-6">
                      <ConstantInput
                        label={localization.chiefGuestDesignation}
                        errorMsg={localization.designationError}
                        type="text"
                        Confirmation
                        required
                        value={firData.chiefguest_designation}
                        isStarRequired={true}
                        handleChange={(val) => {
                          handleInput2Value(val, "chiefguest_designation");
                        }}
                      />
                    </div>
                  </>
                )}
                <div className="col-sm-6">
                  <>
                    {inputList.map((x, i) => {
                      return (
                        <DatePicker
                          label={localization.carnivalDateTime}
                          required={false}
                          value={firData.carnival_datetime}
                          onFocus={(val) => handleSaveDraft(val)}
                          handleChange={(val) => {
                            handleInput2Value(val, "carnival_datetime");
                          }}
                        />
                      );
                    })}
                  </>
                </div>
              </div>

              <h5>Prerequisites for the Carnival</h5>

              <div className="row mt-3">
                <div className="col-sm-12">
                  <TextAreaInput
                    type="text"
                    label={
                      "Identified area and location (Ensure it is more than 15*50 feet in size)"
                    }
                    rows={4}
                    value={formData[0]?.identified_area}
                    className={` inline-css scrollbar-styling`}
                    inputValue={formData[0]?.identified_area}
                    errorMsg={localization.isRequired}
                    handleChange={(val) => {
                      handleInput2Value(val.target.value, "identified_area");
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={localization.flagInstallation}
                    required
                    value={inputList[0]?.flag_installation}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "flag_installation");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Aligning the RWA to ask Residents to come with cars during Carnival"
                    }
                    value={inputList[0]?.aligning_RWA}
                    required
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "aligning_RWA");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Push message and in-app notification to residents prior to the carnival"
                    }
                    required
                    value={inputList[0]?.push_message}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "push_message");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Confirmation for Park+ Associated Partners in Carnival(mandatory)"
                    }
                    required
                    value={inputList[0]?.confirmation_park}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "confirmation_park");
                    }}
                    isStarRequired={true}
                  />
                </div>
                {inputList[0]?.confirmation_park === "Yes" && (
                  <div className="col-sm-12">
                    <TextAreaInput
                      type="text"
                      label={"Remark"}
                      rows={4}
                      className={` inline-css scrollbar-styling`}
                      value={formData[0]?.confirmation_remark}
                      inputValue={formData[0]?.confirmation_remark}
                      errorMsg={localization.isRequired}
                      handleChange={(val) => {
                        handleInput2Value(
                          val.target.value,
                          "confirmation_remark"
                        );
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.rmName}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.rm_name}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "rm_name");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ConstantInput
                    label={localization.clientName}
                    errorMsg={localization.designationError}
                    type="text"
                    required
                    value={firData.client_name}
                    onFocus={(val) => handleSaveDraft(val)}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "client_name");
                    }}
                  />
                </div>
              </div>

              {/* new fields addition starts */}
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client will pay rentals on their own via self deposit flow"
                    }
                    required
                    value={inputList[0]?.client_rental_self_deposit}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "client_rental_self_deposit");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client with payment rentals via online mode"
                    }
                    required
                    value={inputList[0]?.client_rental_online_mode}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "client_rental_online_mode");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client is aware on late payment fee clause if invoice due date is crossed"
                    }
                    required
                    value={inputList[0]?.late_payment_fees_check}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "late_payment_fees_check");
                    }}
                    isStarRequired={true}
                  />
                </div>
                <div className="col-sm-6">
                  <DropDownInput
                    data={[
                      { id: "Yes", name: "Yes" },
                      { id: "No", name: "No" },
                    ]}
                    label={
                      "Client is aware that system auto shuts off if payment are pending for payment since defined time"
                    }
                    required
                    value={inputList[0]?.auto_shuts_off_check}
                    errorMsg={localization.requiredName}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "auto_shuts_off_check");
                    }}
                    isStarRequired={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <DropDownInput
                    data={[
                        {
                            "id":"Yes",
                            "name":"Yes"
                        },
                        {
                            "id":"No",
                            "name":"No"
                        }
                    ]}
                    label={'Do/Will you charge the residents for tags in your society?'}
                    required
                    errorMsg={'This is required'}
                    getIdValue={(val) => {
                      handleInput2Value(val.id, "residents_tags_charge");
                    }}
                    value={inputList[0]?.residents_tags_charge}
                    isStarRequired={true}
                  />
                </div>

            {inputList[0]?.residents_tags_charge == 'Yes' && (
                <div className="col-md-6">
                    <DropDownInput
                        data={[
                            {
                                "id":"Add tag price to maintenance bill",
                                "name":"Add tag price to maintenance bill"
                            },
                            {
                                "id":"Cash/Online while issuing tag",
                                "name":"Cash/Online while issuing tag"
                            }
                        ]}
                        label={'How do you charge them?'}
                        required
                        errorMsg={'This is required'}
                        getIdValue={(val) => {
                          handleInput2Value(val.id, "charge_reason");
                        }}
                        value={inputList[0]?.charge_reason}
                        isStarRequired={true}
                    />
                </div>
            )}
              </div>
              <h5>Market Research</h5>
              <div className="row mt-3">
                <div className="col-md-6">
                  <ConstantInput
                    label={'Number of meetings happened for closure'}
                    type="text"
                    required
                    isStarRequired={true}
                    value={firData.meeting_count}
                    disabled={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "meeting_count");
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <ConstantInput
                    label={'Days taken to convert the deal'}
                    type="text"
                    required
                    isStarRequired={true}
                    value={firData.deal_duration}
                    disabled={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "deal_duration");
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <DropDownInput
                      data={[
                          {
                              "id":"Parksmart",
                              "name":"Parksmart"
                          },
                          {
                              "id":"ESSL",
                              "name":"ESSL"
                          },
                          {
                            "id":"Radius",
                            "name":"Radius"
                        },
                        {
                            "id":"Neptune",
                            "name":"Neptune"
                        },
                        {
                          "id":"Other",
                          "name":"Other"
                        }
                      ]}
                      label={'Which other companies got evaluated along with Park+?'}
                      required
                      errorMsg={'This is required'}
                      getIdValue={(val) => {
                        handleInput2Value(val.id, "evaluated_vendor");
                      }}
                      value={inputList[0]?.evaluated_vendor}
                      isStarRequired={true}
                  />
                </div>
                {inputList[0]?.evaluated_vendor == 'Other' && (
                  <div className="col-md-6">
                    <ConstantInput
                      label={'Other Reason'}
                      errorMsg={'This field is required'}
                      type="text"
                      required
                      value={firData?.evaluated_vendor_others_reason}
                      isStarRequired={true}
                      handleChange={(val) => {
                        handleInput2Value(val, "evaluated_vendor_others_reason");
                      }}
                    />
                  </div>
                )}
                <div className="col-md-6">
                  <ConstantInput
                    label={'What could have been done better to close the deal faster?'}
                    errorMsg={'This field is required'}
                    type="text"
                    required
                    value={firData?.betterment_reason}
                    isStarRequired={true}
                    handleChange={(val) => {
                      handleInput2Value(val, "betterment_reason");
                    }}
                  />
                </div>
              </div>
              {/* new fields addition ends */}
            </div>
          </div>
          <br />
          <br />
          <div className="btn-wrapper">
            <button disabled={false} type="submit" className="btn btn-primary">
              {localization.submit}
              <img src="../images/arrow-right.png" alt="" />
            </button>
            <br />
            <br />
          </div>
        </div>
      </form>
    </Layout>
  );
};

export default FirstInteractionFIRForm;
